import React, { PureComponent } from "react";
import { connect } from "react-redux";
import ImgComputed from "./ImgWrap";
import SafeImage from "./SafeImage";
import "react-mobile-image-viewer/lib/index.css";

import { EditorState, convertFromRaw } from "draft-js";
import Editor from "@draft-js-plugins/editor";
import createLinkifyPlugin from "@draft-js-plugins/linkify";
import createHashtagPlugin from "@draft-js-plugins/hashtag";

import {
    isJsonString,
    getWatchers,
    cdnUrl,
    hasStoredDigg,
    rememberDigg,
} from "@/utils";
import { mapStateToProps } from "@/store";
import { DiggItem } from "@/apis";
import gpsIcon from "@/static/images/icon-gps.svg";

const linkifyPlugin = createLinkifyPlugin({ target: "_blank" });
const hashtagPlugin = createHashtagPlugin();
const plugins = [hashtagPlugin, linkifyPlugin];

const GIMG = gpsIcon;
const getAssetUrl = (src = "") => cdnUrl(src);
const getTextLength = (txt = "") => {
    if (!isJsonString(txt)) return String(txt).trim().length;
    try {
        return JSON.parse(txt).blocks.reduce(
            (length, block) => length + String(block.text || "").length,
            0,
        );
    } catch {
        return String(txt).length;
    }
};

export class Items extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            postxt: EditorState.createEmpty(),
            expanded: false,
            diggPending: false,
            diggCount: Number(props.item?.digg || 0),
            liked: Boolean(
                props.item?.digged || hasStoredDigg(props.item?.objectId),
            ),
            celebrating: false,
        };
    }

    static defaultProps = {
        imglist: [],
    };
    componentDidMount() {
        const { item } = this.props;
        isJsonString(item.txt) &&
            this.setState({
                postxt: EditorState.createWithContent(
                    convertFromRaw(JSON.parse(item.txt)),
                ),
            });
    }
    componentDidUpdate(previousProps) {
        if (
            previousProps.item?.digg !== this.props.item?.digg &&
            !this.state.diggPending
        ) {
            this.setState({ diggCount: Number(this.props.item?.digg || 0) });
        }
    }
    async digg(objectId) {
        if (this.state.liked || this.state.diggPending) return;

        const { dispatch, dailylist = [] } = this.props;
        const previousDailylist = dailylist;
        const optimisticDailylist = dailylist.map((daily) =>
            daily.objectId === objectId
                ? {
                      ...daily,
                      digg: Number(daily.digg || 0) + 1,
                      digged: true,
                  }
                : daily,
        );

        const previousDiggCount = this.state.diggCount;
        this.setState({
            liked: true,
            diggPending: true,
            celebrating: true,
            diggCount: previousDiggCount + 1,
        });
        dispatch({
            type: "UPDATE_DAILY",
            dailylist: optimisticDailylist,
        });

        try {
            const diggRet = await DiggItem(objectId);

            if (diggRet?.code !== 200) {
                throw new Error(diggRet?.msg || "点赞异常~");
            }

            const serverDigg = Number(diggRet.msg?.digg);
            const latestDailylist = this.props.dailylist?.length
                ? this.props.dailylist
                : optimisticDailylist;
            dispatch({
                type: "UPDATE_DAILY",
                dailylist: latestDailylist.map((daily) =>
                    daily.objectId === objectId
                        ? {
                              ...daily,
                              digg: Number.isFinite(serverDigg)
                                  ? serverDigg
                                  : daily.digg,
                              digged: true,
                          }
                        : daily,
                ),
            });
            rememberDigg(objectId);
            this.setState({
                diggPending: false,
                diggCount: Number.isFinite(serverDigg)
                    ? serverDigg
                    : previousDiggCount + 1,
            });
        } catch (err) {
            console.error("点赞异常 =====>", err);
            dispatch({
                type: "UPDATE_DAILY",
                dailylist: previousDailylist,
            });
            dispatch({
                type: "SHOW_TOAST",
                tstmsg: err?.message || "点赞异常~",
            });
            this.setState({
                liked: false,
                diggPending: false,
                celebrating: false,
                diggCount: previousDiggCount,
            });
        }
    }
    detail(id, index) {
        const { history } = this.props;
        history.push({
            pathname: `/item/${id}`,
            query: {
                idx: index,
            },
        });
    }

    render() {
        const { item, index, system } = this.props;
        const watchers = getWatchers(system, item.baby_nos, item.baby);
        const author =
            system?.role?.[item.role] || (item.role === 2 ? "妈妈" : "爸爸");
        const isLongText = getTextLength(item.txt) > 180;
        const { celebrating, diggCount, diggPending, expanded, liked } =
            this.state;
        return (
            <li className="item journal-card" _id={item.objectId}>
                <button
                    type="button"
                    className="journal-card__date"
                    onClick={() => this.detail(item.objectId, index)}
                    aria-label={`查看 ${item._year} 年 ${item._date} 的记录`}
                >
                    <time>
                        <strong>{item._date}</strong>
                        <span>{item._year}</span>
                    </time>
                </button>
                <div className="something">
                    <div
                        className={`journal-card__body ${isLongText && !expanded ? "is-collapsed" : ""}`.trim()}
                    >
                        {isJsonString(item.txt) ? (
                            <Editor
                                editorState={this.state.postxt}
                                onChange={(val) => {
                                    this.setState({ postxt: val });
                                }}
                                readOnly={true}
                                plugins={plugins}
                            />
                        ) : (
                            <p className="txt">{item.txt}</p>
                        )}
                    </div>
                    {isLongText && (
                        <button
                            type="button"
                            className="journal-card__expand"
                            aria-expanded={expanded}
                            onClick={() =>
                                this.setState({ expanded: !expanded })
                            }
                        >
                            {expanded ? "收起" : "展开全文"}
                        </button>
                    )}
                    {<ImgComputed item={item} />}
                    {!!item.addr_gps && !!item.addr_gps.title && (
                        <div className="btm-info">
                            <p className="addr">
                                <img
                                    src={GIMG}
                                    alt={item.addr_gps.title}
                                    className="icon"
                                />
                                {item.addr_gps.title}
                            </p>
                        </div>
                    )}
                </div>
                <footer className="journal-card__footer">
                    <span
                        className={`role ${item.role === 2 ? "female" : ""}`}
                        title={author}
                        aria-label={`由${author}记录`}
                    >
                        <svg className="icon" aria-hidden="true">
                            <use
                                xlinkHref={`#icon-${item.role === 2 ? "049-mother" : "050-father"}`}
                            />
                        </svg>
                    </span>
                    <span
                        className="watcher-stack"
                        aria-label={`关于${watchers.map((watcher) => watcher.name).join("、")}`}
                    >
                        {watchers.map((watcher) =>
                            watcher.avatar ? (
                                <SafeImage
                                    key={watcher.no}
                                    src={getAssetUrl(watcher.avatar)}
                                    alt={watcher.name}
                                    title={watcher.name}
                                />
                            ) : (
                                <span
                                    key={watcher.no}
                                    className="watcher-fallback"
                                    title={watcher.name}
                                >
                                    {watcher.name.slice(-1)}
                                </span>
                            ),
                        )}
                    </span>
                    <button
                        type="button"
                        className={`conner ${liked ? "digged" : ""} ${celebrating ? "is-celebrating" : ""}`.trim()}
                        onClick={() => this.digg(item.objectId)}
                        aria-label={liked ? "已点赞" : "点赞"}
                        aria-pressed={liked}
                        disabled={liked || diggPending}
                    >
                        <svg className="icon candy-icon" aria-hidden="true">
                            <use xlinkHref="#icon-candy" />
                        </svg>
                        <em aria-live="polite">{diggCount}</em>
                    </button>
                </footer>
            </li>
        );
    }
}

export default connect(mapStateToProps)(Items);
